
export class LibSubContractorsDto {
  subContractorId?: number;
  // subContractorCode:string;
  panCardNo:string;
  subContractorName:string;
  emailId:string;
  mobileNo:string;
  bankAccNumber:string;
  ifscCode:string;
  branchName:string;
  status: boolean;
  createdAt : Date | any;
  createdUser : number;
  updatedAt : Date | any;
  updatedUser : number;
  versionFlag : number;
}
export const LibSubContractorsDtoDefault : LibSubContractorsDto = {
  subContractorId: 0,
  // subContractorCode:"",
  panCardNo:"",
  subContractorName:"",
  emailId:"",
  mobileNo:"",
  bankAccNumber:"",
  ifscCode:"",
  branchName:"",
  status: true,
  createdAt : new Date() ,
  createdUser : 0,
  updatedAt : new Date() ,
  updatedUser : 0,
  versionFlag : 1
};